import i18next from 'i18next';

const t = (key, fallback) => {
    const result = i18next.t(key);
    return result !== key ? result : (fallback || key);
};

export const jobLabel = new Proxy({}, {
    get: (_, key) => t(`jobLabel.${key}`, String(key)),
});

export const lineItemLabel = new Proxy({}, {
    get: (_, key) => t(`lineItemLabel.${key}`, String(key)),
});
